import React from 'react';
import { connect } from 'react-redux';
import { changeCompliance, setApprovedSortProperty, setPendingSortProperty, setPendingStepIndex, submitPendingActions, updateAction, updateAllAction, fetchProjectFunctions, updateApprovedAction, fetchActions, submitActions, uploadDeviationFiles, deleteDeviationFile, oneTimeDeviation, selectProject, selectProjectFunction, saveActionProcedureComment } from '../../reduxActions/ActionsActions';
import { showProcedureManual } from '../../reduxActions/ProcedureManualActions';
import { showSnackBarMessage } from '../../reduxActions/AppInfoActions';
import { fetchMyRRDocs } from "../../reduxActions/FunctionsActions";
import { fetchProjects } from '../../reduxActions/ProjectActions';

const ActionsContextV2 = React.createContext({});

const projectHasActions = (project) => {
    if (!project || !project.functions || project.functions.length === 0) {
        return false;
    }

    return project.functions.some((projectFunction) => projectFunction && Number(projectFunction.actions) > 0);
};

const getProjectDisplayName = (project) => {
    if (!project) {
        return '';
    }

    return (project.preferredName || project.name || '').toString().trim();
};

const sortProjectsAlphabetically = (projects) => {
    return [...projects].sort((a, b) => getProjectDisplayName(a).localeCompare(getProjectDisplayName(b), undefined, { sensitivity: 'base' }));
};

class ActionsStore extends React.Component {


    shouldUpdateScrollTop = false;

    componentDidMount() {
        // Always fetch latest project functions
        this.props.fetchProjectFunctions();
        this.props.fetchProjects();
        if (!this.props.myRRDocs || !this.props.myRRDocs.length) {
            this.props.fetchMyRRDocs();
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (props.actionsRedux.projectActionGroups.length !== state.collapsedProjects.length) {
            return {
                collapsedProjects: [...props.actionsRedux.projectActionGroups],
            };
        }

        // Return null if the state hasn't changed
        return null;
    }

    constructor(props) {
        super(props);
        this.scrollRef = React.createRef();

        this.state = {
            editAlternateSdn: false,
            alternateSdnAction: null,
            commentsDialogOpen: false,
            commentsAction: null,
            pendingCompletedTab: 0,
            commentsClearStatusActionOnCancel: false,
            comments: null,
            commentsOriginal: null,
            commentsEditable: false,
            isDeviating: false,
            oneTimeDeviationDialogOpen: false,
            changeComplianceDialogOpen: false,
            changeComplianceAction: null,
            hoverAction: null,
            deviationDialogOpen: false,
            deviationFieldName: null,
            deviationAction: null,
            deviationProcedureSdn: null,
            deviationProcedureUrl: null,
            deviationProcedureName: null,
            deviationReasoningClearApplicabilityOnCancel: false,
            deviationFileUploads: null,
            deviationFileUploadsDeletedIndexes: {},
            scrollTop: 0,
            collapsedForm: false,
            returnProcedureDialogOpen: false,
            returnProcedureAction: null,
            collapsedProjects: [...props.actionsRedux.projectActionGroups],
            searchText: "",
            categoryFilterText: "",
            complianceFilterText: "",
            procedureSdnWithRev: null,
            downloadProcedures: false,
            procedureComment: {},
        };
    }

    updateScrollTop = scrollTop => {
        this.shouldUpdateScrollTop = true;
        this.setState({ scrollTop });
    }

    componentDidUpdate(prevProps) {
        if (this.shouldUpdateScrollTop) {
            this.scrollRef.current.scrollTop = this.state.scrollTop;
            this.shouldUpdateScrollTop = false

        }

        const prevProjects = prevProps.actionsRedux.projectFunctionsMine || [];
        const currentProjects = this.props.actionsRedux.projectFunctionsMine || [];
        const hasNoSelectedProject = !this.props.actionsRedux.selectedProject;
        const currentUser = this.props.aboutCurrentUser;
        const prevUser = prevProps.aboutCurrentUser;
        const gbus = (this.props.projectsRedux && this.props.projectsRedux.gbus) ? this.props.projectsRedux.gbus : [];
        const gbuProjectIds = new Set();
        gbus.forEach((gbu) => {
            (gbu.projects || []).forEach((project) => {
                if (project && project.id) {
                    gbuProjectIds.add(project.id);
                }
            });
        });
        const hasGbuProjects = gbuProjectIds.size > 0;
        const dropdownEligibleProjects = hasGbuProjects
            ? currentProjects.filter((project) => project && gbuProjectIds.has(project.id))
            : currentProjects;
        const didProjectsLoad = prevProjects.length === 0 && currentProjects.length > 0;
        const projectsChanged = prevProjects.length !== currentProjects.length;
        const didUserChange = prevUser !== currentUser;
        const isAdminOrDeveloper = !!currentUser && (currentUser.isAdmin || currentUser.isDeveloper);

        // Non-admin/non-developer users should always land on My Actions with a selected assigned project.
        if (!isAdminOrDeveloper && (didProjectsLoad || projectsChanged || didUserChange) && hasNoSelectedProject && dropdownEligibleProjects.length > 0) {
            const sortedEligibleProjects = sortProjectsAlphabetically(dropdownEligibleProjects);
            const firstProjectWithActions = sortedEligibleProjects.find((project) => projectHasActions(project));
            const firstProjectWithFunctions = sortedEligibleProjects.find((project) => project && project.functions && project.functions.length > 0);
            const defaultProject = firstProjectWithActions || firstProjectWithFunctions;

            if (defaultProject) {
                this.props.selectProject(defaultProject);
            }
        }


    }
    // setHoverAction = hoverAction => this.setState({hoverAction:this.props.aboutCurrentUser.isDeveloper ? hoverAction : null});
    setHoverAction = hoverAction => this.setState({ hoverAction });

    setEditAlternateSdn = editAlternateSdn => this.setState({ editAlternateSdn });
    displayChangeComplianceDialog = changeComplianceAction => { this.setState({ changeComplianceDialogOpen: true, changeComplianceAction }) };
    closeChangeComplianceDialog = () => this.setState({ changeComplianceDialogOpen: false, changeComplianceAction: null });
    setAlternateSdnAction = alternateSdnAction => this.setState({ alternateSdnAction });
    displayOneTimeDeviationDialog = deviationAction => { this.setState({ oneTimeDeviationDialogOpen: true, deviationAction }) };
    closeOneTimeDeviationDialog = () => { this.setState({ oneTimeDeviationDialogOpen: false, deviationAction: null }) };
    setPendingCompletedTab = pendingCompletedTab => { this.setState({ pendingCompletedTab }) };
    setCollapsedProjects = collapsedProjects => { this.setState({ collapsedProjects }) };
    setCollapsedForm = collapsedForm => { this.setState({ collapsedForm }) };

    displayDeviationReasoning = ({ deviationFieldName, action, deviationReasoningClearApplicabilityOnCancel, isEditable }) => this.setState({ deviationAction: { ...action, isEditable }, deviationReasoningClearApplicabilityOnCancel, deviationFieldName, deviationDialogOpen: true });
    closeDeviationReasoning = () => this.setState({ deviationDialogOpen: false, deviationFileUploads: null });
    displayComments = ({ action, commentsEditable, commentsClearStatusActionOnCancel = false }) => this.setState({ commentsAction: action, commentsClearStatusActionOnCancel, commentsEditable, comments: action.comments, commentsOriginal: action.comments, commentsDialogOpen: true, deviationFileUploads: action.deviationFileUploads });
    updateComments = comments => this.setState({ comments });
    closeComments = () => this.setState({ commentsDialogOpen: false });
    updateDeviationFiles = deviationFileUploads => {
        this.setState({ deviationFileUploads });
    }
    updateDeviationFileDeletedIndex = (index) => {
        const value = !this.state.deviationFileUploadsDeletedIndexes[index]
        this.setState({ deviationFileUploadsDeletedIndexes: { ...this.state.deviationFileUploadsDeletedIndexes, [index]: value } });
    }
    uploadPendingDeviationFiles = () => {

        if (this.state.deviationFileUploads && this.state.deviationFileUploads.length > 0) {

            const deviationFileUploads = this.state.deviationFileUploads.filter((item, index) => !this.state.deviationFileUploadsDeletedIndexes[index]);
            const procedureId = this.state.changeComplianceAction ? this.state.changeComplianceAction.procedureId : this.state.deviationAction.procedureId;
            this.props.uploadDeviationFiles({ files: deviationFileUploads, procedureId });
        }

    }

    setSearchText = searchText => this.setState({ searchText });
    setCategoryFilterText = categoryFilterText => this.setState({ categoryFilterText });
    setComplianceFilterText = complianceFilterText => this.setState({ complianceFilterText });
    setProcedureSdnWithRev = procedureSdnWithRev => { this.setState({ procedureSdnWithRev }) };
    setDownloadProcedures = downloadProcedures => this.setState({ downloadProcedures });
    setProcedureComment = procedureComment => { this.setState({ procedureComment }) };

    render() {

        return (

            <ActionsContextV2.Provider
                value={
                    {
                        ...this.state,
                        ...this.props,
                        setEditAlternateSdn: this.setEditAlternateSdn,
                        setAlternateSdnAction: this.setAlternateSdnAction,
                        setCollapsedForm: this.setCollapsedForm,
                        setCollapsedProjects: this.setCollapsedProjects,
                        setPendingCompletedTab: this.setPendingCompletedTab,
                        displayOneTimeDeviationDialog: this.displayOneTimeDeviationDialog,
                        closeOneTimeDeviationDialog: this.closeOneTimeDeviationDialog,
                        displayDeviationReasoning: this.displayDeviationReasoning,
                        closeDeviationReasoning: this.closeDeviationReasoning,
                        updateDeviationReasoning: this.updateDeviationReasoning,
                        displayComments: this.displayComments,
                        updateComments: this.updateComments,
                        closeComments: this.closeComments,
                        updateDeviationFiles: this.updateDeviationFiles,
                        setSearchText: this.setSearchText,
                        uploadPendingDeviationFiles: this.uploadPendingDeviationFiles,
                        updateisDeviating: this.updateisDeviating,
                        showGroupedActions: this.showGroupedActions,
                        scrollRef: this.scrollRef,
                        updateScrollTop: this.updateScrollTop,
                        displayChangeComplianceDialog: this.displayChangeComplianceDialog,
                        closeChangeComplianceDialog: this.closeChangeComplianceDialog,
                        setHoverAction: this.setHoverAction,
                        setCategoryFilterText: this.setCategoryFilterText,
                        setComplianceFilterText: this.setComplianceFilterText,
                        updateDeviationFileDeletedIndex: this.updateDeviationFileDeletedIndex,
                        setProcedureSdnWithRev: this.setProcedureSdnWithRev,
                        setDownloadProcedures: this.setDownloadProcedures,
                        setProcedureComment: this.setProcedureComment,
                    }
                }>
                {this.props.children}
            </ActionsContextV2.Provider>

        );
    }
}

const mapStateToProps = state => {

    return { contentWidth: state.app.contentSize.width, contentHeight: state.app.contentSize.height, actionsRedux: state.actions, aboutCurrentUser: state.app.aboutCurrentUser, myRRDocs: state.functions.myRRDocs, projectsRedux: state.projects };
}

ActionsStore = connect(mapStateToProps, { changeCompliance, setApprovedSortProperty, setPendingSortProperty, submitPendingActions, setPendingStepIndex, updateAction, updateAllAction, fetchProjectFunctions, fetchProjects, selectProject, selectProjectFunction, showSnackBarMessage, updateApprovedAction, fetchActions, oneTimeDeviation, submitActions, uploadDeviationFiles, showProcedureManual, deleteDeviationFile, saveActionProcedureComment, fetchMyRRDocs })(ActionsStore);

export { ActionsStore };


export default ActionsContextV2;